import React from 'react';
import PropTypes from 'prop-types';
import { Context } from '../../Context';
import { withStyles } from '@material-ui/core/styles';
import { Tabs, Tab, Paper, Button, AppBar, Toolbar, Card, CardContent, CardActions, CardMedia, IconButton, Tooltip, ExpansionPanel, Switch, ExpansionPanelSummary, Badge, ExpansionPanelDetails, Grid, Typography, CircularProgress, Divider } from '@material-ui/core/';
import CampaignDetailsStyles from '../../Styles/CampaignDetailsStyles';
import moment from 'moment';
import { Mixpanel } from '../../Config/mixpanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfluencerDetails from '../InfluencerDetails';
import SaveIcon from '@material-ui/icons/Save';
import { CSVLink } from 'react-csv';
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'


import './styles.css';

class CampaignDetailsMagicLink extends React.Component {
	constructor() {
		super();

		this.state = {
			loading: true,
			fsLoader: false,
			campaign: null,
			acceptPostsDialogOpen: false,
			tabSelected: 0,
			csvData: []
		};
	}

	componentDidMount() {
		this.context.actions.getAdvertiserCampaignsMagicLink(this.props.match.params.magicLink, (err, campaign) => {
			if (err) {
				return window.alert('An unknown error has occured, please contact hello@vimma.co with a screenshot. Thanks!');
			}

			this.setState({
				campaign,
				loading: false
			}, () => {
				this.generateCSV();
			});


			Mixpanel.track('Loaded magicLink campaign', {
				magicLink: this.props.match.params.magicLink,
				campaignName: campaign.name,
				numberOfInfluencers: campaign.influencers ? campaign.influencers.length : 0
			});
		});

		Mixpanel.track('Viewed magicLink campaign', {
			magicLink: this.props.match.params.magicLink
		});
	}

	updateAdvertiserCampaignInfluencers = (statusChanges) => {
		this.setState({ fsLoader: true }, () => {
			if (statusChanges && statusChanges.length !== 0) {
				this.context.actions.patchAdvertiserCampaignsMagicLink(this.props.match.params.magicLink, statusChanges, (err, campaign) => {
					if (err) {
						return window.alert('An unknown error has occured, please contact hello@vimma.co with a screenshot. Thanks!');
					}
					this.setState({
						campaign,
						fsLoader: false
					}, () => {
						this.generateCSV();
					});

				});
			}
		});
	}

	generateCSV = event => {
		let csv = [['InfluencerId', 'Email', 'Followers', 'Engagement']];

		if (this.state.campaign && this.state.campaign.influencers.length > 0) {
			this.state.campaign.influencers.filter(inf => {
				if (inf.status === 'AcceptedByBrand') {
					let influencerEmail = 'Unknown';

					if (inf.email) {
						influencerEmail = inf.email;
					} else if (inf.igTag.email) {
						influencerEmail = inf.igTag.email;
					}

					csv.push([
						inf.influencerId ? inf.influencerId : 'Unknown',
						influencerEmail,
						inf.edge_followed_by && inf.edge_followed_by.count ? inf.edge_followed_by.count : 'Unknown',
						inf.postEngagementPercent ? `${inf.postEngagementPercent.toFixed(2)}%` : 'Unknown'
					]);
				}
			});
		}

		this.setState({ csvData: csv });
	}

	handleTabChange = (event, tabSelected) => {
		this.setState({ tabSelected });
	};

	exportCSV = event => {
		Mixpanel.track('MagicLink campaign CSV export', {
			campaignName: this.state.campaign.name,
			magicLink: this.props.match.params.magicLink,
			exportedInfluencers: this.state.campaign.influencers ? this.state.campaign.influencers.length : 0
		});

		this.csvLinkRef.link.click();
	};

	openTidio = event => {
		if (window.tidioChatApi) {
			window.tidioChatApi.show();
			window.tidioChatApi.open();
		}
	}

	render() {
		const { classes } = this.props;
		const { campaign } = this.state;

		const newInfluencers = campaign ? campaign.influencers.filter(inf => inf.status === 'ListSent') : [];
		const contactedInfluencers = campaign ? campaign.influencers.filter(inf => inf.status === 'AcceptedByBrand') : [];
		const rejectedInfluencers = campaign ? campaign.influencers.filter(inf => inf.status === 'RejectedByBrand') : [];

		return (
			<div>
				<LoadingOverlay
					active={this.state.fsLoader}
					spinner
					text='Updating...'
				>
					<AppBar position="static">
						<Toolbar>
							<Typography variant="h6" style={{ flexGrow: 1 }}>
								Vimma Content Creators
    					</Typography>
							<Button color="inherit" onClick={this.openTidio}>
								Help
						</Button>
						</Toolbar>
					</AppBar>
					{this.state.loading
						? (<CircularProgress size={24} className={classes.progress} />)
						: (
							<React.Fragment>
								<Typography variant='h5' className={classes.typography}>Influencers interested in {campaign.name}</Typography>
								<Divider />
								<div style={{ padding: 10 }}>
									<Tabs
										value={this.state.tabSelected}
										onChange={this.handleTabChange}
										indicatorColor="primary"
										textColor="primary"
										style={{ marginTop: 10 }}
									>
										<Tooltip title='These creators would love to work with you. Click add to shortlist and get in touch!'>
											<Tab label={`New (${newInfluencers.length})`} />
										</Tooltip>
										<Tooltip title='More details about your shortlisted creators.'>
											<Tab label={`Shortlisted (${contactedInfluencers.length})`} disabled={contactedInfluencers.length === 0} />
										</Tooltip>
										<Tooltip title="You have not selected these creators. You can still change your mind and add them to your shortlist.">
											<Tab label={`Rejected (${rejectedInfluencers.length})`} disabled={rejectedInfluencers.length === 0} />
										</Tooltip>
									</Tabs>
									<div style={{ padding: 10 }}>
										{this.state.tabSelected === 0 && (
											<Grid container spacing={4}>
												{newInfluencers.length === 0 && (
													<Typography variant="body1" style={{ paddingTop: 20 }}>
														There’s no creators interested in your brand right now. Contact Vimma to get a new list!
													</Typography>
												)}
												{newInfluencers.map((inf) => (
													<Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={inf._id}>
														<InfluencerDetails
															influencer={inf}
															key={inf._id}
															updateInfluencers={this.updateAdvertiserCampaignInfluencers}
															campaignName={this.state.campaign.name}
															magicLink={this.props.match.params.magicLink}
														/>
													</Grid>
												))}
											</Grid>
										)}
										{this.state.tabSelected === 1 && (
											<Grid container spacing={4}>
												<Grid item xs={12}>
													<Tooltip title='Export shortlisted creators to CSV file.'>
														<Button
															color='primary'
															size='small'
															variant='contained'
															startIcon={<SaveIcon />}
															onClick={this.exportCSV}
															disabled={contactedInfluencers.length === 0}>
															Export
													</Button>
													</Tooltip>
													<CSVLink
														ref={ref => this.csvLinkRef = ref}
														data={this.state.csvData}
														target="_blank"
														filename={`${moment().format('YYYY-MM-DDTHH:MM')}_export.csv`}
														style={{ display: 'none' }}
													>
														download
												</CSVLink>
												</Grid>
												{contactedInfluencers.map((inf) => (
													<Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={inf._id}>
														<InfluencerDetails
															influencer={inf}
															key={inf._id}
															updateInfluencers={this.updateAdvertiserCampaignInfluencers}
															campaignName={this.state.campaign.name}
															magicLink={this.props.match.params.magicLink} />
													</Grid>
												))}
											</Grid>
										)}
										{this.state.tabSelected === 2 && (
											<Grid container spacing={4}>
												{rejectedInfluencers.map((inf) => (
													<Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={inf._id}>
														<InfluencerDetails
															influencer={inf}
															key={inf._id}
															updateInfluencers={this.updateAdvertiserCampaignInfluencers}
															campaignName={this.state.campaign.name}
															magicLink={this.props.match.params.magicLink} />
													</Grid>
												))}
											</Grid>
										)}
									</div>
								</div>
							</React.Fragment>
						)
					}
				</LoadingOverlay>
			</div>
		);
	}
}

CampaignDetailsMagicLink.propTypes = {
	classes: PropTypes.object.isRequired
};

CampaignDetailsMagicLink.contextType = Context;

export default withStyles(CampaignDetailsStyles)(CampaignDetailsMagicLink);
